class HeroSlideshow extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero-slideshow__dot'));
    this.arrows = Array.from(this.querySelectorAll('.hero-slideshow__arrow'));
    this.activeIndex = 0;
    this.intervalId = null;

    if (this.slides.length < 2) return;

    const speed = parseFloat(getComputedStyle(this).getPropertyValue('--hero-slideshow-speed'));
    this.intervalMs = (Number.isFinite(speed) ? speed : 4.5) * 1000;

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goTo(index, { resetTimer: true }));
    });

    this.arrows.forEach((arrow) => {
      const direction = Number(arrow.dataset.direction);
      arrow.addEventListener('click', () => {
        const nextIndex = (this.activeIndex + direction + this.slides.length) % this.slides.length;
        this.goTo(nextIndex, { resetTimer: true });
      });
    });

    this.addEventListener('mouseenter', this.stop);
    this.addEventListener('mouseleave', this.start);
    this.addEventListener('focusin', this.stop);
    this.addEventListener('focusout', this.start);
    document.addEventListener('visibilitychange', this.#handleVisibilityChange);

    this.start();
  }

  disconnectedCallback() {
    this.stop();
    document.removeEventListener('visibilitychange', this.#handleVisibilityChange);
  }

  #handleVisibilityChange = () => {
    if (document.hidden) this.stop();
    else this.start();
  };

  start = () => {
    if (this.intervalId || this.slides.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    this.intervalId = setInterval(() => this.advance(), this.intervalMs);
  };

  stop = () => {
    clearInterval(this.intervalId);
    this.intervalId = null;
  };

  advance() {
    this.goTo((this.activeIndex + 1) % this.slides.length);
  }

  goTo(index, { resetTimer = false } = {}) {
    if (index === this.activeIndex) return;

    this.slides[this.activeIndex]?.classList.remove('is-active');
    this.dots[this.activeIndex]?.classList.remove('is-active');
    this.activeIndex = index;
    this.slides[this.activeIndex]?.classList.add('is-active');
    this.dots[this.activeIndex]?.classList.add('is-active');

    if (resetTimer) {
      this.stop();
      this.start();
    }
  }
}

customElements.define('hero-slideshow', HeroSlideshow);
